import React from 'react';
import RecoverableImage from '../images/RecoverableImage';
import { useMusicGenreCatalogRevision } from '../taste/generated/localization';
import Link from './BrowseLink';
import ContentTitle from '../../pages/playlist/PlaylistItemTitle';
import { albumGenre } from '../../pages/review/components/album/albumIntroPresentation';
import ArtistLink from '../../components/common/ArtistLink';

import { PreviewButton } from '../preview/PreviewControls';
import { trackListContentClick } from '../../lib/gaEvents';
import { CONTENT_TYPE, LIST_ACTION_TYPE } from '../../constants/gaEnums';
import { useUserStore } from '../../stores/userStore';
import { useWebLocale } from '../../contexts/WebLocaleContext';
export function playlistArtwork(playlist) {
  const items = playlist.type === 'TRACK' ? playlist.tracks : playlist.albums;
  return {
    ...playlist,
    previewImageUrls: [
      ...new Set(
        [
          ...(playlist.previewImageUrls || []),
          ...[...(items || [])]
            .sort((a, b) => a.position - b.position)
            .map((item) => item.albumImageUrl),
        ].filter(Boolean),
      ),
    ].slice(0, 4),
  };
}
export function playlistExternalUrl(value) {
  try {
    const url = new URL(value);
    return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
}
function ItemLink({ to, children, ...props }) {
  return to ? (
    <Link to={to} {...props}>
      {children}
    </Link>
  ) : (
    <span>{children}</span>
  );
}
export default function PlaylistDetailItem({ item, type, track, queue, owner }) {
  useMusicGenreCatalogRevision();
  const user = useUserStore((s) => s.user);
  const { locale } = useWebLocale();
  const isTrack = type === 'TRACK';
  const slug = isTrack ? item.albumSlug : item.slug,
    sourceId = isTrack ? item.albumSourceId : item.sourceId;
  const to = slug
    ? `/reviews/${encodeURIComponent(slug)}${sourceId ? `?${new URLSearchParams({ source_id: sourceId })}` : ''}`
    : sourceId
      ? `/reviews/${String(item.albumSource || 'APPLE_MUSIC').toLowerCase()}/${encodeURIComponent(sourceId)}`
      : null;
  const artist = isTrack ? { name: item.artistName } : item.artist;
  const contentType = isTrack ? CONTENT_TYPE.LIST_SONG : CONTENT_TYPE.LIST_ALBUM;
  const logAlbum = () =>
    trackListContentClick(
      {
        contentType,
        actionType: LIST_ACTION_TYPE.ALBUM_CLICK,
        contentId: `album_${isTrack ? item.albumId || item.albumSourceId : item.id || item.sourceId}`,
        contentName: isTrack ? item.albumTitle : item.title,
      },
      user,
    );
  const artwork = (
    <span className="pp-playlist-detail-item-artwork">
      {item.albumImageUrl ? (
        <RecoverableImage src={item.albumImageUrl} alt="" loading="lazy" />
      ) : (
        'P'
      )}
      {isTrack && (
        <span className="pp-playlist-artwork-play">
          <PreviewButton track={track} queue={queue} owner={owner} showProgress />
        </span>
      )}
    </span>
  );
  return (
    <article className={`pp-playlist-detail-item${isTrack ? ' is-track' : ''}`}>
      {isTrack ? (
        artwork
      ) : (
        <ItemLink
          to={to}
          onClick={logAlbum}
          aria-label={`${locale === 'en' ? 'Open album' : '앨범 보기'} · ${item.title}`}
        >
          {artwork}
        </ItemLink>
      )}
      <div className="pp-playlist-detail-item-copy">
        <ItemLink to={to} onClick={logAlbum}>
          <ContentTitle title={item.title} explicit={item.contentRating === 'EXPLICIT'} />
          {isTrack && artist?.name && (
            <span className="pp-playlist-detail-item-artist">{artist.name}</span>
          )}
        </ItemLink>
        {!isTrack && artist?.name && (
          <ArtistLink
            artistName={artist.name}
            artistSource={artist.artistSource}
            artistSourceId={artist.sourceId}
            artistSlug={artist.slug}
            artistDbId={artist.id}
            onClick={() =>
              trackListContentClick(
                {
                  contentType,
                  actionType: LIST_ACTION_TYPE.ARTIST_CLICK,
                  contentId: `artist_${artist.sourceId}`,
                  contentName: artist.name,
                },
                user,
              )
            }
            sx={{ fontSize: 14, lineHeight: '19px', color: 'inherit' }}
          />
        )}
        {!isTrack && (
          <span className="pp-playlist-detail-item-meta">
            {[
              item.releaseDate?.slice(0, 10).replaceAll('-', '.'),
              item.genreNames
                ?.slice(0, 2)
                .map((g) => albumGenre(g, locale))
                .join(', '),
            ]
              .filter(Boolean)
              .join(' · ')}
          </span>
        )}
      </div>
    </article>
  );
}
